import type { ConditionalFieldRules } from "@huub-web/ui/types/ConditionalFieldRules";
import { isArray } from "@huub-web/utils";
import type { TemplatesProviderState } from "../contexts";

/**
 * Checks if the rules are met for the given data field values.
 * @param rules - The rules to check the visibility against.
 * @param dataFieldValues - The data field values to check the rules against.
 * @returns True if the rules are met, false otherwise.
 */
export const isConditionalIf = (
  rules: ConditionalFieldRules | undefined,
  dataFieldValues: TemplatesProviderState["dataFieldValues"],
) => {
  if (!rules) {
    return true;
  }

  return rules.every((rule) => {
    if (!rule.field) {
      console.warn("No field provided for rule", rule);
      return true;
    }

    const value = dataFieldValues[rule.field]?.value;

    if (rule.condition?.type === "equals") {
      // console.log(
      //   `[!!!] isConditionalIf rule: '${rule.field}' ${rule.condition?.type}`,
      //   value,
      //   "/ result:",
      //   rule.condition.value === value,
      // );

      return rule.condition.value === value;
    } else if (rule.condition?.type === "notEquals") {
      // console.log(
      //   `[!!!] isConditionalIf rule: '${rule.field}' ${rule.condition?.type}`,
      //   value,
      //   "Result:",
      //   rule.condition.value === value,
      // );

      return rule.condition.value !== value;
    } else if (rule.condition?.type === "in") {
      if (isArray(rule.condition.value)) {
        return rule.condition.value.includes(value as string);
      } else {
        console.warn(
          "Value for includes condition is not an array",
          rule.condition,
        );
      }
      return false;
    } else if (rule.condition?.type === "isEmpty") {
      return value === null || value === undefined || value === "";
    }

    console.warn(
      `Invalid rule type '${rule.condition?.type ?? "unknown"}' (or not yet implemended)`,
    );

    return true;
  });
};
